import styled from "styled-components";
import { ToggleView } from "../views/toggle-view";
import squareLoader from "../../square-loader.json";
import { Player } from "@lottiefiles/react-lottie-player";

const OverlayContainer = styled.div`
  position: relative;
`;

const SpinnerOverlay = styled.div`
  position: absolute;
  top: 0px;
  z-index: 900;
  background-color: black;
  opacity: 0.5;
  height: 150%;
  min-height: 500px;
  width: 100%;
  margin: 0;
`;

const OverlayDiv = styled.div`
  height: 100%;
`;

const SpinnerDiv = styled.div`
  height: 100%;
  z-index: 1000;
  margin-top: 10%;
  color: orange;
`;

const SpinnerImage = styled.img`
  z-index: 1000;
  width: 7rem;
  height: 4rem;
`;

export const LoadingOverlay = ({ isLoading, title, message, children }) => {
  return (
    <OverlayContainer>
      <ToggleView show={isLoading}>
        <SpinnerOverlay>
          <OverlayDiv className="loader-container">
            <SpinnerDiv className="text-center">
              <Player src={squareLoader} className="player" autoplay loop />
              {/* <div>
                            <h3>{title}</h3>
                            <p>{message}</p>
                        </div> */}
            </SpinnerDiv>
          </OverlayDiv>
        </SpinnerOverlay>
      </ToggleView>
      {children}
    </OverlayContainer>
  );
};
